module.exports = __webpack_public_path__ + "img/app-store-badge-ru.56e181e7.svg";